{
  "title": "Dashboard",
  "greeting": "Welcome, {{name}}!",
  "activeSchool": "You're viewing {{school}}.",
  "quickActions": {
    "title": "Quick actions",
    "description": "The two things that get a school going.",
    "inviteMember": "Invite a member",
    "createClass": "Create a class"
  },
  "myClasses": {
    "title": "My classes",
    "empty": "You are not enrolled in any class yet — join one with a code from your teacher.",
    "join": "Join by code",
    "viewAll": "All classes"
  },
  "myChildren": {
    "title": "My children",
    "empty": "No children are linked to you yet — ask the school to link them."
  },
  "toGrade": {
    "title": "To grade",
    "description": "Work waiting for your review.",
    "submissions": "Homework submissions",
    "attempts": "Test attempts",
    "empty": "Nothing is waiting for grading right now.",
    "openSubmissions": "Review submissions",
    "openAttempts": "Review attempts",
    "count_one": "{{count}} item",
    "count_other": "{{count}} items"
  },
  "dueSoon": {
    "title": "Due soon",
    "description": "Homework and tests to get to.",
    "empty": "Nothing is due in the next week.",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "homework": "Homework",
    "test": "Test",
    "viewHomework": "All homework",
    "viewTests": "All tests"
  },
  "childrenSummary": {
    "title": "My children",
    "description": "Their latest homework.",
    "viewAll": "See all",
    "empty": "No homework has been handed in yet."
  },
  "glance": {
    "title": "School at a glance",
    "teachers": "Teachers",
    "pupils": "Pupils",
    "classes": "Classes",
    "invitations": "Pending invites",
    "year": "Showing classes for {{name}}."
  }
}
